'use client';

import SendPic from '@/ui/assets/send-icon.svg';
import { Button, Heading, Icon, Text, Translation } from '@/ui/components';
import cn from 'classnames';
import Image from 'next/image';

import s from './ResetPasswordSent.module.css';

const ResetPasswordSent = () => {
  return (
    <article className={cn(s.wrapper)}>
      <Image src={SendPic} className={s.picture} alt="Success Image" />

      <Heading spacing="tiny" centerText weight="medium">
        <Translation context="reset_password_success" token="title" />
      </Heading>
      <Text centerText spacing="semi">
        <Translation context="reset_password_success" token="description" />
      </Text>
      <footer className={s.footer}>
        <Button isFullWidth spacing="small">
          <Translation context="reset_password_success" token="resend_button" />
        </Button>
        <Button
          isFullWidth
          variant="link"
          icon={<Icon variant="solid" name="ChevronLeft" color="iris-500" />}
          href={`/account/login`}
        >
          <Translation context="reset_password_success" token="back_button" />
        </Button>
      </footer>
    </article>
  );
};

export default ResetPasswordSent;
